import React from 'react'
import Compressor from 'compressorjs'
import Button from '@mui/material/Button'
import { isEmpty } from 'lodash'
import { extensionToLowerCase } from '../../../resources/Utils'

const ChooseImage = ({
  max,
  images,
  setImages,
  elementsAdded,
  isGalleryForm,
  setErrorLabel,
  isMessageEnabled = true,
  fireDepartmentIdentifier,
  marketingDialog = false,
  marketingSetter = null,
  localMarketingSetter = null,
  setMarketingError,
  disableHandleClick = false
}) => {
  const hiddenFileInput = React.useRef(null)

  const handleClick = (event) => {
    if (!disableHandleClick) {
      hiddenFileInput.current.click()
    }
    
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }

  const addImage = (image) => {
    const file = {}
    const fileName = extensionToLowerCase(image.name)

    file.object = image
    let add = true
    if (max > 1 && elementsAdded === max) {
      if (marketingDialog) {
        setMarketingError((prevState) => ({
          ...prevState,
          errorLabel: 'Max number of files'
        }))
      } else {
        setErrorLabel('Max number of files')
      }

      add = false
    }

    const size = formatBytes(image.size)
    file.fileSize = size
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.bmp)$/i
    if (size > 25) {
      file.error = 'File limit exceeds'
      add = false
    } else if (!allowedExtensions.exec(fileName)) {
      file.error = 'File extension not allowed'
      add = false
    }

    if (add) {
      file.file = image
      file.caption = ''
      file.originalName = fileName
      file.previewImage = URL.createObjectURL(image)
      file.fileName = `${fileName.split('.')[0]}_${Date.now().toString()}.${fileName.split('.')[1]}`
      file.isNew = true
      if (!isGalleryForm) file.fireDepartmentIdentifier = fireDepartmentIdentifier
      file.type = 'image'
      if (max > 1) {
        if (marketingDialog) {
          marketingSetter((prevState) => ({
            ...prevState,
            images: [...prevState.images, file]
          }))
        } else {
          setImages([...images, file])
        }
      } else {
        if (marketingDialog) {
          marketingSetter((prevState) => ({
            ...prevState,
            images: [file]
          }))
        } else {
          setImages([file])
        }
      }
      hiddenFileInput.current.value = null
    } else {
      if (max > 1 && elementsAdded === max) {
        if (marketingDialog) {
          localMarketingSetter((prevState) => ({
            ...prevState,
            errorLabel: 'Max number of files'
          }))
        } else {
          setErrorLabel('Max number of files')
        }
      } else {
        if (marketingDialog) {
          localMarketingSetter((prevState) => ({
            ...prevState,
            errorLabel: file.error
          }))
        } else {
          setErrorLabel(file.error)
        }
      }
      setTimeout(() => {
        if (marketingDialog) {
          localMarketingSetter((prevState) => ({
            ...prevState,
            errorLabel: ''
          }))
        } else {
          setErrorLabel('')
        }
      }, 5000)
    }
  }

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0]

    // if the setting is not set, defaults to 5MB
    const maxImageSize = isEmpty(window._env_.COMMUNITY_MAX_IMAGE_SIZE_BYTES)
      ? 5000000
      : parseInt(window._env_.COMMUNITY_MAX_IMAGE_SIZE_BYTES, 10)

    if (fileUploaded) {
      if (fileUploaded.size >= maxImageSize) {
        imageCompressor(fileUploaded).then((compressedImage) => addImage(compressedImage))
      } else {
        addImage(fileUploaded)
      }
    }
  }

  return (
    <>
      <div style={{ height: '100px' }}>
        <Button
          onClick={handleClick}
          style={{ maxWidth: '250px', minWidth: '250px' }}
          variant="outlined"
          color="primary"
          className="button form-control"
          id='choose-img-btn'
          size="medium"
        >
          Choose image
        </Button>
        {isMessageEnabled ? (
          max > 1 ? (
            <p
              style={{
                padding: '3px 0px',
                fontStyle: 'italic',
                fontSize: '14px',
                fontFamily: 'lato',
                fontWeight: 'normal',
                textAlign: 'left',
                color: '#535353',
                opacity: '1',
                maxWidth: '280px',
                minWidth: '280px'
              }}
            >
              You can add up to {max} files (images, videos) and unlimited online videos
            </p>
          ) : (
            <p
              style={{
                padding: '3px 0px',
                fontStyle: 'italic',
                fontSize: '14px',
                fontFamily: 'lato',
                fontWeight: 'normal',
                textAlign: 'left',
                color: '#535353',
                opacity: '1',
                maxWidth: '280px',
                minWidth: '280px'
              }}
            >
              Supported max 50MB in format jpg, jpeg, png and bmp
            </p>
          )
        ) : (
          <p></p>
        )}
      </div>
      <input
        type="file"
        accept=".jpg,.jpeg,.png,.bmp"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </>
  )
}

function imageCompressor(image) {
  return new Promise((resolve, reject) => {
    // Images below 250kb are not required to be re-compressed
    // so they can preserve their quality
    const quality = image.size > 250000 ? 0.9 : 1

    new Compressor(image, {
      convertSize: 1,
      quality: quality,
      maxHeight: 800,
      maxWidth: 1280,
      success(compressedImage) {
        resolve(compressedImage)
      },
      error(e) {
        reject(false)
      }
    })
  })
}

export default ChooseImage
